/** Brand palette */
export const PALETTE = {
  navy:   '#214469',
  blue:   '#97B8CB',
  brown:  '#694B1D',
  gold:   '#D4B346',
  green:  '#3F8533',
  grey:   '#403B32',
  sand:   '#D0B39C',
  teal:   '#1A8888',  // Riverine vegetation
  /** ⚠ Anomaly / warning only — do not use for decorative purposes. */
  red:    '#A00A00',
} as const;

export const AREA_COLORS: Record<string, string> = {
  'Chewore North': PALETTE.navy,
  'Sapi':          PALETTE.green,
  'Kapiri':        PALETTE.gold,
};

/** Ordered palette list — excludes red/grey. Used for cycling color assignments. */
export const CYCLE = [
  PALETTE.navy, PALETTE.blue, PALETTE.brown,
  PALETTE.gold, PALETTE.green, PALETTE.teal, PALETTE.sand,
] as const;

export function areaColor(area: string): string {
  return AREA_COLORS[area] ?? PALETTE.blue;
}

export function cycleColor(index: number): string {
  return CYCLE[index % CYCLE.length];
}

/** Derive species color from its dominant survey area (used in Scene1 only). */
export function speciesColor(domArea: string, index: number): string {
  return AREA_COLORS[domArea] ?? cycleColor(index);
}
